<template>
  <div id="printReport">
    <div class="row">
      <div class="col-sm-2">
        <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
      </div>
      <div class="col-sm-8">
        <h3 class="text-center">Relatório de Convesão de Leads</h3>
      </div>
      <div class="col-sm-2"></div>
    </div>
    <br />
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-defaul">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-4">
                <label>Loja</label>
                <br />
                <div>{{ !form.branche_id ? 'TODAS' : store_branch}}</div>
              </div>
              <div class="col-md-4">
                <label>Administradora</label>
                <br />
                <div>
                    {{ !administrator_id_ ? 'TODAS' : administrator }}
                </div>
              </div>

              <div class="col-md-4">
                <label>Equipe</label>
                <br />
                <div>
                    {{ !team_name ? 'TODAS' : team_name.name }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label>Vendedor</label>
                <br />
                <div>
                    {{ !salesman_name ? 'TODAS' : salesman_name.name }}
                </div>
              </div>
              <div class="col-md-4">
                <label>Período da venda</label>
                <br />
                <div>
                  {{ !date_reference ? 'TODAS' : date_reference }}
                </div>
              </div>
              <div class="col-md-4">
                <label>Período da criação do lead</label>
                <br />
                <div>
                  {{ !date_reference_lead ? 'TODAS' : date_reference_lead }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label>Gerador Por:</label>
                <br />
                 <div>{{ user_auth_name }}</div>
              </div>
              <div class="col-md-4">
                <label>Criado em:</label>
                <br />
                 <div>{{ new Date() | moment('DD/MM/YYYY') }} às {{ new Date() | moment('H[:]mm[h]')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   
    <div class="row" v-show="report.length">
      <div class="col-md-12">
        <div class="panel panel-default">
          <div class="panel-body">
            <table class="table b-table table-sm" id="tabela">
              <thead class="thead-dark">
                <tr>
                  <th class="text-center">Vendedor</th>
                  <th class="text-center">Leads</th>
                  <th class="text-center">Vendas</th>
                  <th class="text-center">Taxa de Conversão</th>
                  <th class="text-center">Valor das Vendas</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(iterator, key) of report">
                  <tr v-if="iterator.leads > 0" :key="key">
                    <td v-if="iterator.leads > 0">
                      <div>
                        <a href="" @click.prevent.stop="showDetailsAdministrator( iterator )"><b>{{ iterator.name }}</b></a>
                        <md-tooltip style="color:red;">Clique para exibir detalhes </md-tooltip>
                      </div>

                    </td>
                    <td v-if="iterator.leads > 0" class="text-center">{{ iterator.leads }}</td>
                    <td v-if="iterator.leads > 0" class="text-center">{{ iterator.sells }}</td>
                    <td v-if="iterator.leads > 0" class="text-center">{{ Math.round((iterator.conversion)) }}%</td>
                    <td v-if="iterator.leads > 0" class="text-center">R$ {{ iterator.value  | price}}</td>
                  </tr>
                </template>
                <tr>
                  <td class="text-right" style="background-color:#ccc;"><b>Totais:</b></td>
                  <td class="text-center" style="background-color:#ccc;">{{ totals.leads }}</td>
                  <td class="text-center" style="background-color:#ccc;">{{ totals.sells }}</td>
                  <td class="text-center" style="background-color:#ccc;">{{ Math.round(totals.conversion) }}%</td>
                  <td class="text-center" style="background-color:#ccc;">R$ {{ totals.value  | price}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="exibe_detalhamento">
      <div class="col-sm-12">
        <div class="panel panel-default">
          <div class="panel-body">
            <table class="table b-table table-sm" id="tabela2">
              <thead>
                <tr>
                  <th>Vendedor</th>
                  <th colspan="4">{{objAdministrator.name}}</th>
                </tr>
              </thead>
              <thead class="thead-dark">
                <tr>
                  <th class="text-center" style="">Cliente</th>
                  <th class="text-center">Contrato</th>
                  <th class="text-center">Data do Lead</th>
                  <th class="text-center">Data da Venda</th>
                  <th class="text-center">Valor da Venda</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(iterator, key) of detail" :key="key">
                  <td class="text-center">{{ iterator.clients_name || iterator.leads_name || '-'}}</td>
                  <td class="text-center">{{ iterator.physical_proposal || '-'}}</td>
                  <td class="text-center">{{moment(iterator.leads_created_at).format('DD/MM/YYYY HH:mm')}}</td>
                  <td class="text-center">{{iterator.sale_at ? moment(iterator.sale_at).format('DD/MM/YYYY HH:mm') : '-'}}</td>
                  <td class="text-center">R$ {{ iterator.value  | price}}</td>
                </tr>
                <tr>
                  <td class="text-right" style="background-color:#ccc;"><b>Totais:</b></td>
                  <td class="text-center" style="background-color:#ccc;">{{ detail_totals.leads }}</td>
                  <td class="text-center" style="background-color:#ccc;"></td>
                  <td class="text-center" style="background-color:#ccc;"></td>
                  <td class="text-center" style="background-color:#ccc;">R$ {{ detail_totals.value  | price}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row dont-print">
      <div class="col-md-12 text-center">
        <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
        <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
        <!--button-- type="button" v-show="report.length" @click="excel()" class="btn btn-fill btn-success">Excel</!--button-->
      </div>
    </div>
  </div>
</template>
<script>

    import Vue from "vue";

export default {
  components: {},
  computed: {
      administrators: {
          get() {
              return this.$store.state.administrators.itens;
      }
    },
    sum_commissions(){
      return (this.$store.state.reports.item.length) ? this.$store.state.reports.item[0].sum_commissions : [];
	  },
  	sum_commissions_details(){
      return (this.$store.state.reports.detail.length) ? this.$store.state.reports.detail[0].sum_commissions : [];
    },
    user_auth_name(){
        return this.$store.state.auth.user.name.toUpperCase();
    },
    branches() {
      return this.$store.state.defaults.branches;
    },
    dates: {
      get() {
        var dates = [
          { id: "sale_date", name: "Data da Venda" },
          { id: "due_date", name: "Data de Vencimento" },
          { id: "payday", name: "Data de Pagamento" }
        ];

        return dates;
      }
    },
	reportDetail(){
		return this.$store.state.reports.detail;
	}
  },
  data() {
    return {
        moment: Vue.moment,
      administrator: null,
        objAdministrator: null,
      store_branch: null,
      team_name: null,
      salesman_name: null,
      teams: [],
      date_reference : null,
      date: null,
      end_at: null,
      form: {},
      init_at: null,
    team: null,
    date_reference_lead: null,
	  sum_line:0,
	  exibe_detalhamento : false,
	    administrator_detail : null,
	    administrator_id_ : null,
	    report: [],
	    totals: {
          leads: 0,
		    sells: 0,
		    conversion: 0,
		    value: 0
	    },
        detail_totals: {
          leads: 0,
		    sells: 0,
		    conversion: 0,
		    value: 0
	    },
	    detail: []
    };
  },
  methods: {

  async getDataTeams(id) {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch('teams/get', 1);

      response.then(async function (data) {
          self.$root.$emit("onLoading");
          self.team_name = await data;
          //self.getUsers();
      });

      response.catch(function () {
          self.$root.$emit("onLoading");
      });
  },

   async getUsers(_param) {
                var self = this;

                self.$root.$emit('onLoading');

                const response =  self.$store.dispatch('users/get', _param);
                
                response.then(function (x) {
                    self.salesman_name = x;
                    console.log(`salesman_name`,self.salesman_name, ' x ', x);
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },

	async showDetailsAdministrator(objAdministrator){
		const self = this;

		self.objAdministrator = objAdministrator;
		self.detail = objAdministrator.objects;
        self.exibe_detalhamento = true;

        self.detail_totals = {
            leads: 0,
                sells: 0,
                conversion: 0,
                value: 0
        };

        for(let item of self.detail){
            self.detail_totals.leads += 1;

            if(item.salesman_id) {
                self.detail_totals.sells += 1;
                self.detail_totals.value = parseFloat(self.detail_totals.value ) + parseFloat(item.value);
            }
        }

        self.totals.detail_totals = self.detail_totals.sells / self.detail_totals.leads;
	},
	sumExtractColumnData( column, commissions){
		if(commissions.length !== undefined){
			var elens = commissions.map(item => Number( eval('item.'+column) ));
			return elens.reduce((total, amount) => total + amount);
		}
	},
	sumCommissions( commissions, index){
    if(commissions.length !== undefined){
			var elens = commissions.map(item => Number(item.sum_commissions[index].parcela) );

			return elens.reduce((total, amount) => total + amount);
    }
	},
    close() {
      window.opener.focus();
      window.close();
    },
    async getDataAdministrators() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("administrators/all");
  
      response.then(function(_administrators) {
         var administrator = _administrators.find(
           administrator => administrator.id === self.form.administrator_id
         );
         if (administrator !== undefined) {
           self.administrator = administrator.name;
         }
        self.$root.$emit("onLoading");
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });


        //Carrega os dados do relatório.
        self.getData();
    },
    async getData(){
        var self = this;
        const report = {};

        self.$root.$emit("onLoading");
        console.log('self.form ', self.form)
        const response = self.$store.dispatch('reports/leadConversion', self.form);


        response.then(function (res) {
            const leads = res.leads;
            self.totals = {
                leads: 0,
                    sells: 0,
                    conversion: 0,
                    value: 0
            };

            for(let seller of res.selers){
                report[seller.id] = {
                    name: seller.name,
	                leads: 0,
	                sells: 0,
	                conversion: 0,
	                value: 0,
	                objects: []
                }
            }

            for(let lead of leads){
                const user = lead.user_id;
                if(report[user]){
	                report[user].leads += 1;
                    self.totals.leads += 1;
                    report[user].objects.push(lead);

	                if(lead.salesman_id){
	                    report[user].sells += 1;
                      report[user].value = parseFloat(report[user].value) + parseFloat(lead.value);
                      
                      self.totals.sells += 1;
                      self.totals.value = parseFloat(self.totals.value) + parseFloat(lead.value);
	                }

	                report[user].conversion = (report[user].sells / report[user].leads) * 100;
	                self.totals.conversion = (self.totals.sells / self.totals.leads) * 100;
                }
            }
            console.log('report-r', report);
            self.report = Object.values(report);
            self.$root.$emit("onLoading");
        });

        response.catch(function () {
            self.$root.$emit("onLoading");
        });
    },
    print() {
      window.print();
    },
    excel() {
      var nome = "RELATÓRIO DE PRODUÇÃO MENSAL";
      var htmlPlanilha =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
        nome +
        "</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><title>" +
        nome +
        "</title></head><body><table>" +
        document.getElementById("tabela").innerHTML + document.getElementById("tabela2").innerHTML +
        "</table>";
      var htmlBase64 = btoa(htmlPlanilha);
      var link = "data:application/vnd.ms-excel;base64," + htmlBase64;
      var hyperlink = document.createElement("a");
      hyperlink.download = "Relatório de Produção Mensal";
      hyperlink.href = link;
      hyperlink.style.display = "none";
      document.body.appendChild(hyperlink);
      hyperlink.click();
      document.body.removeChild(hyperlink);
    },

  },
  async mounted() {
    var self = this;

    self.form = JSON.parse(self.$route.query.form);
    self.store_branch   = self.form.branche_id ? self.branches.find(item => item.id === self.form.branche_id).name.toUpperCase() : null;
              
    self.administrator_id_ = self.form.administrator_id;
    
    self.getDataAdministrators();
    if(self.form.team_id) {
       self.getDataTeams(self.form.team_id);
    } 

    if(self.form.responsible_id) {
      self.getUsers(self.form.responsible_id);
    }   

    // self.date = self.dates.find(date => date.id === self.form.date_by).name;
    if(self.form.sale_at[0]) {
          self.date_reference = `${self.moment(self.form.sale_at[0]).format('DD/MM/YYYY')} à ${self.moment(self.form.sale_at[1]).format('DD/MM/YYYY')}`; 
    }
    if(self.form.date_at[0]) {
      self.date_reference_lead = `${self.moment(self.form.date_at[0]).format('DD/MM/YYYY')} à ${self.moment(self.form.date_at[1]).format('DD/MM/YYYY')}`;
    }
    console.log('self.teams ', self.teams)
  }
};
</script>
<style type="scss">
@media print {
  .dont-print {
    display: none;
  }
}
</style>

<style scoped>

</style>
